import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  margin: 2rem;
`;

// Without this, one thrown render error unmounts the whole app and leaves a
// blank page. Keeping it inside Layout means the header and nav survive, so a
// broken page is recoverable by clicking somewhere else.
class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Caught by ErrorBoundary:", error, info);
  }

  componentDidUpdate(prevProps) {
    // let the user navigate away from a broken page instead of being stuck
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <Wrapper>
          <h2>Something went wrong on this page.</h2>
          <p>
            This is usually a hiccup in one of the third-party data feeds. Try
            reloading, or pick another page from the menu.
          </p>
          <button className="btn btn-default" onClick={() => window.location.reload()}>
            Reload
          </button>
        </Wrapper>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
